package com.tregz.tremenz.ui.icon

/**
 * Platform neutral handle on an icon. Each target resolves a key to its own drawable through
 * [iconPainter]; common code never touches `R` or a platform vector.
 */
enum class IconKey {
    BEER,
    COCKTAIL,
    COLLAPSE,
    CONTACT,
    DAY,
    EXPAND,
    INFO,
    INSTANT_MIX,
    MUSIC,
    NEWS,
    NIGHT,
    OUTPUT,
    PAUSE,
    PHOTOS,
    PLAY,
    RADIO,
    TREMENZ,
    TV,
    VIDEO,
    WINE,
    WORDMARK
}
